var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSalaryCertificate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15625 14.9766V15.4766H3.65625H7.23438V15.7422H2.95312C2.91813 15.7422 2.89062 15.7147 2.89062 15.6797V1.89844C2.89062 1.86345 2.91813 1.83594 2.95312 1.83594H14.2031C14.2381 1.83594 14.2656 1.86345 14.2656 1.89844V7.86719H14V2.60156V2.10156H13.5H3.65625H3.15625V2.60156V14.9766ZM12.2969 13.4297V13.9297H12.7969H15.1094V16.1641H9.35938V13.9297H11.6719H12.1719V13.4297V12.7863V12.4136L11.8147 12.3072C11.2071 12.1261 10.7656 11.5627 10.7656 10.8984C10.7656 10.0865 11.4224 9.42969 12.2344 9.42969C13.0463 9.42969 13.7031 10.0865 13.7031 10.8984C13.7031 11.5642 13.2619 12.126 12.6541 12.3072L12.2969 12.4136V12.7863V13.4297ZM14.5195 16.0742H15.0195V15.5742V14.5195V14.0195H14.5195H9.94922H9.44922V14.5195V15.5742V16.0742H9.94922H14.5195ZM5.5625 5.01953V4.89453H11.5938V5.01953H5.5625ZM5.5625 7.55078V7.42578H8.07812V7.55078H5.5625ZM12.2344 9.51953C11.4731 9.51953 10.8555 10.1371 10.8555 10.8984C10.8555 11.6597 11.4731 12.2773 12.2344 12.2773C12.9957 12.2773 13.6133 11.6597 13.6133 10.8984C13.6133 10.1371 12.9957 9.51953 12.2344 9.51953Z",
    stroke: "#0077B8"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSalaryCertificate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/salaryCertificate.cbfe8596.svg";
export { ForwardRef as ReactComponent };